import { Input, Output, EventEmitter } from "@angular/core";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-star-rating",
  templateUrl: "./star-rating.component.html",
  styleUrls: ["./star-rating.component.css"]
})
export class StarRatingComponent implements OnInit {
  constructor() { }

  @Input()
  value: number;

  @Input()
  max?: number = 5;

  @Input()
  disabled: boolean;

  @Output()
  valueChange = new EventEmitter<number>();

  ngOnInit() { }

  onClick(value) {
    if (!this.disabled) {
      this.value = value;
      this.valueChange.emit(this.value);
    }
  }
}
